import { LinkRelationship, Source } from '../../enums';
import { Contact, ContactSummary } from '../contact';
import { AuditDetails, Entity, LinkableEntity } from '../entity';
import { JobBudget, WorkOrderStatus } from '../job';
import { PricingMethod } from '../price.book';
import { ActivityEntityName, Address, Attachment, CostSource, EmbeddedCode } from '../shared';
import { QuotePolicy } from '../policies';
import { SiteProTiny } from '../crm/sites';

export enum ItemSectionType {
    Items = 'Items',
    CostOnly = 'Cost Only',
    Content = 'Content'
}

export interface ItemSection extends Entity {
    type: ItemSectionType;
    description?: string;

    items: EmbeddedCode[];

    totalBuy?: number;
    totalSellEx?: number;
    totalAdjustment?: number;
    totalTax?: number;
    totalSellInc?: number;

    // Deprecated in favor of type
    costOnly?: boolean;
}

export enum QuoteSimpleStatus {
    Draft = 'Draft',

    PendingApproval = 'Pending Approval',
    ChangesRequired = 'Changes Required',

    Approved = 'Approved',
    AwaitingAcceptance = 'Awaiting Acceptance',
    AwaitingPayment = 'Awaiting Payment',
    Accepted = 'Accepted',
    Declined = 'Declined',
    Cancelled = 'Cancelled',
}

export enum QuoteNotificationType {
    QuoteSent = 'QuoteSent',
}

export type QuoteType = 'Standalone';

export type QuoteModule = ActivityEntityName.Job | ActivityEntityName.Opportunity | ActivityEntityName.Quote | ActivityEntityName.QuotePro | ActivityEntityName.Work;

export interface QuotePricingOptions {
    costSource?: CostSource;
    pricingMethod?: PricingMethod;
    multiplier?: number;
    priceList?: Entity;
}

export interface QuotePro extends LinkableEntity, QuotePricingOptions, AuditDetails {

    status?: QuoteSimpleStatus;
    quoteNumber: string;

    sections?: ItemSection[];
    theme?: Entity;
    terms?: string;
    date: Date;
    expiryDate: Date;

    note?: string;
    description: string;

    account?: Contact;
    company?: Entity;
    owner?: Entity;
    address?: Address;
    contact?: ContactSummary;
    customerQO?: string;

    /** @description Set from Quote Template -> apply to Quote */
    quoteName?: string;

    totalBuy?: number;
    totalSellEx?: number;
    totalAdjustment?: number;
    totalTax?: number;
    totalSellInc?: number;

    prepaymentEx?: number;
    prepaymentTax?: number;
    prepaymentInc?: number;

    overridePrepaymentEx?: number;
    overridePrepaymentInc?: number;
    overridePrepaymentTax?: number;

    source?: Source;
    imported?: boolean;

    integrationId?: string;
    budget?: JobBudget;

    customerRef?: string;
    tags?: Entity[];

    approvalDate?: Date;
    acceptedDate?: Date;
    sentDate?: Date;

    signature?: string;
    poAttachments?: Attachment[];
    poNumber?: string;

    approver?: Entity;
    acceptor?: Entity;

    policy?: QuotePolicy;
    version?: number;
    template?: Entity;

    changesRequiredNote?: string;
    isExpired?: boolean;

    jobType?: Entity;
    // Introduce site to support standalone quote. Address
    // should be deprecated (for quote) in the future.
    site?: SiteProTiny;

    // Introduce sitePro to support standalone quote with new
    // site collection. Going to relace site after job creation
    // with site pro is completed.
    // Currently just use to verify create standalone quote flow
    // is working.
    //sitePro?: SitePro;

    type?: QuoteType;
    pdf?: string;

    reasonForCancellation?: string;
}


export interface QuoteConvertRequest {

    /** @description Quote Id */
    _id: string;

    /** @description this is equal newStageType_single.name */
    name?: string;

    newStage?: boolean;
    newStageType?: {
        type: 'single',
        name?: string;
    } | {
        type: 'multiple',
        baseOn: 'itemCategories' | 'quoteSections';
    }

    /** @description Existing StageId */
    workOrderId?: string;
    jobId?: string;
    status?: WorkOrderStatus;
}

export interface QuoteBuildRequest {
    type?: QuoteType;
    templateId?: string;

    linkEntity?: ActivityEntityName;
    linkEntityId?: string;
    linkRelationship?: LinkRelationship;
}
